<style>
</style>

<template>

<div class="container-fluid">
    <div class="card animated fadeIn">
        <b-form @submit.prevent="addUser()">
            <b-row>
                <b-col sm=8>
                    <b-card>
                        <div slot="header">
                            <strong>Add User:</strong>
                        </div>
                        <div>
                            <div>
                                <div>
                                    <b-form-group label="Name:" label-for="name" :label-cols-sm="2">
                                        <b-form-input type="text" v-model="user.name" v-validate="'required'" id="name" name="name" :state="validateState('name')"></b-form-input>
                                        <div v-if="submitted && verrors.has('name')" class="invalid-feedback">{{ verrors.first('name') }}</div>
                                    </b-form-group>
                                    <b-form-group label="Email:" label-for="email" :label-cols-sm="2">
                                        <b-form-input type="email" v-model="user.email" v-validate="'required|email'" id="email" name="email" :state="validateState('email')"></b-form-input>
                                        <div v-if="submitted && verrors.has('email')" class="invalid-feedback">{{ verrors.first('email') }}</div>
                                    </b-form-group>

                                    <b-form-group label="Account:" label-for="account" :label-cols-lg="3" v-if="account_opts.length != 0">
                                        <b-form-select key="account" v-model="user.account_id" :options="account_opts" v-validate="'required'" id="account" name="account" value-field="id" text-field="name">
                                        </b-form-select>
                                    </b-form-group>




                                    <b-form-group label="Role:" label-for="role" :label-cols-sm="3">
                                        <multiselect v-model="value" :options="role_opts" :multiple="true" v-validate="'required'" name="role" :show-labels="true" label="label" track-by="id">
                                        </multiselect>
                                    </b-form-group>


                                    <b-form-group label="Password: (8-15 characters)" label-for="password" :label-cols-lg="3">
                                        <b-form-input type="password" v-model="user.password" placeholder="" v-validate="'required|min:8|max:15'" id="password" name="password" ref="password" :state="validateState('password')"></b-form-input>
                                        <div v-if="submitted && verrors.has('password')" class="invalid-feedback">{{ verrors.first('password') }}</div>
                                    </b-form-group>
                                    <b-form-group label="Password:" label-for="password_confirmation" :label-cols-sm="2">
                                        <b-form-input type="password" v-model="user.password_confirmation" v-validate="'required|confirmed:password'" placeholder="Confirm password" id="password_confirmation" name="password_confirmation" :state="validateState('password_confirmation')"></b-form-input>
                                        <div v-if="submitted && verrors.has('password_confirmation')" class="invalid-feedback">{{ verrors.first('password_confirmation') }}</div>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                    </b-card>
                </b-col>
                <b-col sm=4>
                    <b-card>
                        <div slot="header">
                            <strong>Details</strong>
                        </div>
                        Info goes here
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm=8>
                    <div class="text-center">
                        <!-- TODO only activate when dirty -->
                        <button :disabled="verrors.any()" class="btn btn-primary">Save</button>
                    </div>
                </b-col>
            </b-row>
        </b-form>
    </div>
</div>

</template>

<script>

import Multiselect from 'vue-multiselect'
import {
    vm
}
from '@/app.js'

export default {
    components: {

        Multiselect,
    },
    data() {

        return {
            user: {},
            submitted: false,
            account_opts: [],
            role_opts: [],
            sel_role_opts: [],
            selectedAccounts: [],
            selectedRoles: [],
            selectedIds: [],
            value: [],

        };

    },
    // https://github.com/shentao/vue-multiselect/issues/263
    watch: {
        value(newValues) {
            this.selectedIds = newValues.map(obj => obj.id);
        }
    },


    created() {
        let uri = `/api/users/create`;
        axios.get(uri).then((response) => {
            // this.account_opts = response.data.data.account_opts;
            let a =  response.data.data.account_opts;
            if(!a || a.length === 0){
                this.account_opts = [];
            }else{
                this.account_opts = a;
            }
            this.role_opts = response.data.data.role_opts;


        });



    },
    computed: {
        optionsArray() {
            return Object.keys(this.options).map(i => this.options[i]);
        }
    },


    methods: {
        // toArray(obj_obj) {
        //   return Object.keys(obj_obj).map(i => obj_obj[i]);
        // },
        validateState(ref) {
                if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                    return !this.verrors.has(ref)
                }
                return null
            },


            addUser() {
                this.submitted = true;
                this.user.role_list = this.selectedIds;
                this.$validator.validate().then(valid => {
                    if (valid) {
                        let uri = `/api/users/`;
                        axios.post(uri, this.user).then((response) => {

                                if (response.data.success === true) {
                                    console.log(response.data);
                                    this.makeToast('info', 'User updated.');
                                    location.reload();
                                } else {
                                    console.log(error.response.data.message);
                                    this.makeToast('danger', 'Unable to update user.');
                                }
                            })
                            .catch(function(error) {
                                if (error.response && error.response.status == 422) {
                                    vm.$setErrorsFromResponse(error.response.data);
                                }
                            });

                    }
                });
            },
            makeToast(variant = null, message = null) {

                this.$bvToast.toast(message, {
                    // title: `Config Updated ${variant || 'default'}`,
                    title: `Notification:`,
                    variant: variant,
                    toaster: 'b-toaster-top-center',
                    solid: true
                });
                // toast.show();
            },
    }

}

</script>
